var _defs, _path, _ellipse, _ellipse2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 450 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_3);}.cls-2{fill:url(#Degradado_sin_nombre_3-2);}.cls-3{fill:#fff;}.cls-4{fill:#8bb34a;}.cls-5{fill:url(#Degradado_sin_nombre_3-3);}.cls-6{fill:url(#Degradado_sin_nombre_3-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: 93.13,
    y1: 42.54,
    x2: 282.74,
    y2: 70.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0095d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a5199"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-2",
    x1: 4,
    y1: 295.87,
    x2: 454,
    y2: 295.87,
    gradientTransform: "translate(197.84 -76.97) rotate(32.96)",
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-3",
    x1: -1411.51,
    y1: 16.32,
    x2: 1452.01,
    y2: 440.28,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-4",
    x1: 276.85,
    y1: 59.47,
    x2: 378.23,
    y2: 74.48,
    xlinkHref: "#Degradado_sin_nombre_3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo reloj") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.25,94.62l-2.13-30.46,14.18-3.23c8-1.82,14-9.54,13.45-17.23L241.8,16c-.53-7.7-7.41-12.46-15.39-10.64L140.56,25c-8,1.82-14,9.53-13.43,17.23l1.93,27.67c.54,7.69,7.43,12.46,15.39,10.64l14.19-3.24L161,110.5",
    transform: "translate(-4 -5)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 229,
    cy: 295.87,
    rx: 235.78,
    ry: 196.83,
    transform: "translate(-128.12 167.22) rotate(-32.96)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 229,
    cy: 295.87,
    rx: 170.43,
    ry: 143.55,
    transform: "translate(-128.18 167.41) rotate(-32.99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.11,263.65l83.5-53.78a16.08,16.08,0,0,1,6.74-2.55,15.86,15.86,0,0,1,2.18-.15h.3a16.06,16.06,0,0,1,12.24,6.06l19.07-16.42c-43.35-52.19-127.6-52.21-188.22,0l58.68,70.65A35.33,35.33,0,0,1,220.11,263.65Z",
    transform: "translate(-4 -5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.76,280.06c-7.31,6.3-9,16.49-3.77,22.79s15.4,6.3,22.71,0a20.2,20.2,0,0,0,3.09-3.41l65.75-76-84.18,54.22A20.52,20.52,0,0,0,224.76,280.06Z",
    transform: "translate(-4 -5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M327,95.26l8.17-21,7,1.66c3.94.93,8.45-1.65,10-5.77L358,55.39c1.62-4.12-.27-8.21-4.22-9.14l-42.54-10c-3.95-.93-8.44,1.65-10.06,5.76l-5.77,14.8c-1.61,4.12.29,8.21,4.23,9.14l7,1.66-8.45,21.67",
    transform: "translate(-4 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.b8c901aebf8881f03ed203e553edcd9d.svg";
export { ForwardRef as ReactComponent };